import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './PopUpLogin.module.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Modal } from 'react-bootstrap';
import { faFacebook, faGoogle, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { IResolveParams, LoginSocialFacebook, LoginSocialGoogle, LoginSocialLinkedin, LoginSocialTwitter } from 'reactjs-social-login';
import { useAuth } from '../../../context/AuthContext';
import { useBanner } from '../../../context/BannerContext';
import CloseButton from '../../CloseButton/CloseButton';
import { LoginForm } from '../../../global';
import { on } from 'events';
import { useForm } from 'react-hook-form';
import FormField from '../../Forms/FormField';
import ErrorBlock from '../../Forms/ErrorBlock';

interface PopUpLoginProps {
  visible: boolean;
  callback: (success: boolean) => void;
}

const PopUpLoginWLF: React.FC<PopUpLoginProps> = (props) => {
  const { createAndAddBannerMessage } = useBanner();

  const { login, fbLogin, ggLogin, hideLoginPopup } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState('');
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<LoginForm>({ mode: 'onBlur', reValidateMode: 'onBlur' });

  useEffect(() => {
    if (props.visible) {
      reset();
      setError('');
    }
  }, [props.visible, reset]);
  
  const onSubmit = async (fd: LoginForm) => {
    setError('');
    login(fd.email, fd.pwd, fd.rememberMe)
      .then((data) => {
        if (data) {
          createAndAddBannerMessage('Welcome to Desall!', 'success', 'welcomeMessage');
          hideLoginPopup();
          props.callback(true);
        } else {
          setError('Unknown error');
        }
      })
      .catch((e) => {
        console.log(e);
        setError('Wrong username or password');
      });
  };

  const facebookLogin = async (token: string, uid: string, email: string) => {
    setError('');
    fbLogin(email, token, uid)
      .then((data) => {
        if (data) {
          hideLoginPopup();
          props.callback(true);
        } else {
          setError('Unknown error');
        }
      })
      .catch((e) => {
        console.log(e);
        setError('An error occurred');
      });
  };

  const googleLogin = async (token: string, uid: string, email: string) => {
    ggLogin(email, token, uid)
      .then((data) => {
        if (data) {
          hideLoginPopup();
          props.callback(true);
        } else {
          setError('Unknown error');
        }
      })
      .catch((e) => {
        console.log(e);
        setError('An error occurred');
      });
  };

  return (
    <>
      <Modal show={props.visible} onHide={() => console.log('MODAL CLOSE')} className={`d-flex flex-column justify-content-center `} contentClassName={` ${styles.rounded}`}>
        <div className={`d-flex flex-column justify-content-center text-center  full bg-light-gray ${styles.rounded}`}>
          <Modal.Body className="d-flex justify-content-center">
            <div className="row justify-content-center align-items-center">
              <div className="col-12">
                <div className="d-flex justify-content-end w-100">
                  <CloseButton
                    callback={() => {
                      hideLoginPopup();
                      props.callback(false);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 mb-4">
                <span className="bigger-text-bold ">Please login</span>
              </div>
              <div className="col-12 mb-6">
                <span className="text ">
                  Not registered yet?{' '}
                  <a href="/signup" target="_self" className="me-1">
                    signup
                  </a>
                  now!
                </span>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="col-12">
                <div className="d-flex justify-content-center">
                  <div className="col-10">
                    <FormField name="email" label="Username or E-mail" fullWidth required error={errors.email}>
                      <input
                        id="email"
                        type="text"
                        placeholder="username or e-mail"
                        className="text-center"
                        {...register('email', { required: 'Please insert username or email' })}
                      />
                    </FormField>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="col-10">
                    <FormField name="pwd" label="Password" fullWidth required error={errors.pwd}>
                      <input id="pwd" type="password" placeholder="password" className="text-center" {...register('pwd', { required: 'Please insert password' })} />
                    </FormField>
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <div className="col-10 ">
                    <FormField name="rememberMe" fullWidth>
                      <div className="d-flex align-items-center">
                        <input type="checkbox" id="checkbox-1" className="" {...register('rememberMe')} />
                        <label htmlFor="checkbox-1" className="d-block text-start ps-4 py-2 text">
                          Remember me
                        </label>
                      </div>
                    </FormField>
                  </div>
                </div>
                <ErrorBlock error={error ? { message: error } : undefined} />

                <div className="row m-4">
                  <div className="col-12  d-flex justify-content-center ">
                    <button className="btn-dark-blue rounded submit">Login</button>
                  </div>
                </div>
              </form>
              <div className="col-12 mb-4 mt-4">
                <span className="sub-title ">or connect with</span>
              </div>

              <div className="d-flex flex-row align-items-center justify-content-center mb-4">
                <div className="col-5 pe-3">
                  <LoginSocialGoogle
                    client_id={process.env.REACT_APP_GG_APP_ID || ''}
                    scope="openid profile email"
                    redirect_uri={'/'}
                    onReject={() => console.log('error')}
                    onResolve={({ provider, data }: IResolveParams) => {
                      console.log(data);
                      googleLogin(data?.access_token, data?.sub, data?.email);
                    }}
                  >
                    <button className="btn-social__google full rounded ">
                      <div className="btn-icon ">
                        <FontAwesomeIcon icon={faGoogle as IconProp} className="text color-light" />
                      </div>
                      google
                    </button>
                  </LoginSocialGoogle>
                </div>
                <div className="col-5 ps-3">
                  <LoginSocialFacebook
                    appId={process.env.REACT_APP_FB_APP_ID || ''}
                    onResolve={({ provider, data }: IResolveParams) => {
                      console.log(data);
                      console.log(data?.accessToken);
                      facebookLogin(data?.accessToken, data?.userID, data?.email);
                    }}
                    onReject={(err: any) => {
                      console.log(err);
                    }}
                  >
                    <button className="btn-social__facebook full rounded">
                      <div className="btn-icon">
                        <FontAwesomeIcon icon={faFacebook as IconProp} className="text color-light" />
                      </div>
                      facebook
                    </button>
                  </LoginSocialFacebook>
                </div>
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center mb-4">
                <div className="col-5  pe-3"></div>
                <div className="col-5  ps-3"></div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default PopUpLoginWLF;
